export default __webpack_public_path__ + "static/media/template20.382fae94.svg";